const initialState = {
  name: "",
  state: "new", // new/connecting/connected/disconnected/closed,
  roomRecordingState: "stop", // stop/recording/paused,
  locked: false,
  webinar: false,
  inLobby: false,
  signInRequired: false,
  accessCode: "", // access code to the room if locked and joinByAccessCode == true
  joinByAccessCode: true, // if true: accessCode is a possibility to open the room
  activeSpeakerId: null,
  showSettings: false,
  fullScreenConsumer: null, // ConsumerID
  windowConsumer: null, // ConsumerID
  toolbarsVisible: true,
  mode: "democratic",
  selectedPeerId: null,
  spotlights: [],
  settingsOpen: false,
  leaveDialogOpen: false,
  joined: false,
  muteAllInProgress: false,
  stopAllVideoInProgress: false,
  closeMeetingInProgress: false,
  startLiveStreamingDialogOpen: false,
  userRoles: { NORMAL: "normal" }, // Default role
  permissionsFromRoles: {
    CHANGE_ROOM_LOCK: [],
    PROMOTE_PEER: [],
    SEND_CHAT: [],
    SHARE_SCREEN: [],
    SHARE_FILE: [],
    MODERATE_ROOM: [],
    MODERATE_WEBINAR: [],
    WEBINAR_SPEAKER: [],
    RECORD: [],
    SURVEY: [],
    REQUEST_REMOTE_CONTROL: [],
  },
  recordingNotificationStatus: false,
  startTime: 0,
  isOfficialReportOpenGlobal: false,
};

const room = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ROOM_NAME": {
      const { name } = action.payload;

      return { ...state, name };
    }

    case "SET_ROOM_STATE": {
      const roomState = action.payload.state;

      if (roomState === "connected") return { ...state, state: roomState };
      else return { ...state, state: roomState, activeSpeakerId: null };
    }

    case "SET_ROOM_RECORDING_STATE": {
      const roomRecordingState = action.payload.state;
      return { ...state, roomRecordingState };
    }

    case "SET_ROOM_LOCKED": {
      return { ...state, locked: true };
    }

    case "SET_ROOM_UNLOCKED": {
      return { ...state, locked: false };
    }

    case "SET_IN_LOBBY": {
      const { inLobby } = action.payload;

      return { ...state, inLobby };
    }

    case "SET_SIGN_IN_REQUIRED": {
      const { signInRequired } = action.payload;

      return { ...state, signInRequired };
    }

    case "SET_ACCESS_CODE": {
      const { accessCode } = action.payload;

      return { ...state, accessCode };
    }

    case "SET_JOIN_BY_ACCESS_CODE": {
      const { joinByAccessCode } = action.payload;

      return { ...state, joinByAccessCode };
    }

    case "SET_LEAVE_DIALOG_OPEN": {
      const { leaveDialogOpen } = action.payload;

      return { ...state, leaveDialogOpen };
    }

    case "SET_SETTINGS_OPEN": {
      const { settingsOpen } = action.payload;

      return { ...state, settingsOpen };
    }

    case "SET_START_LIVE_STREAMING_DIALOG_OPEN": {
      const { startLiveStreamingDialogOpen } = action.payload;

      return { ...state, startLiveStreamingDialogOpen };
    }

    case "SET_ROOM_ACTIVE_SPEAKER": {
      const { peerId } = action.payload;
      // does not update state if same
      if (peerId !== state.activeSpeakerId) {
        return { ...state, activeSpeakerId: peerId };
      }
      return state;
    }

    case "TOGGLE_JOINED": {
      return { ...state, joined: !state.joined };
    }

    case "TOGGLE_FULLSCREEN_CONSUMER": {
      const { consumerId } = action.payload;
      const currentConsumer = state.fullScreenConsumer;

      return {
        ...state,
        fullScreenConsumer: currentConsumer ? null : consumerId,
      };
    }

    case "SWITCH_FULLSCREEN_CONSUMER": {
      const { consumerId } = action.payload;

      return {
        ...state,
        fullScreenConsumer: consumerId,
      };
    }

    case "TOGGLE_WINDOW_CONSUMER": {
      const { consumerId } = action.payload;
      const currentConsumer = state.windowConsumer;

      if (currentConsumer === consumerId)
        return { ...state, windowConsumer: null };
      else return { ...state, windowConsumer: consumerId };
    }

    case "SET_TOOLBARS_VISIBLE": {
      const { toolbarsVisible } = action.payload;

      return { ...state, toolbarsVisible };
    }

    case "SET_DISPLAY_MODE":
      return { ...state, mode: action.payload.mode };

    case "SET_SELECTED_PEER": {
      const { selectedPeerId } = action.payload;

      return {
        ...state,

        selectedPeerId:
          state.selectedPeerId === selectedPeerId ? null : selectedPeerId,
      };
    }

    case "SET_SPOTLIGHTS": {
      const { spotlights } = action.payload;

      return { ...state, spotlights };
    }

    case "MUTE_ALL_IN_PROGRESS":
      return { ...state, muteAllInProgress: action.payload?.flag };

    case "STOP_ALL_VIDEO_IN_PROGRESS":
      return { ...state, stopAllVideoInProgress: action.payload?.flag };

    case "CLOSE_MEETING_IN_PROGRESS":
      return { ...state, closeMeetingInProgress: action.payload?.flag };

    case "SET_USER_ROLES": {
      const { userRoles } = action.payload;

      return { ...state, userRoles };
    }

    case "SET_PERMISSIONS_FROM_ROLES": {
      const { permissionsFromRoles } = action.payload;

      return { ...state, permissionsFromRoles };
    }

    case "SET_ROOM_WEBINAR": {
      const { flag } = action.payload;
      return { ...state, webinar: flag };
    }

    case "SET_START_TIME": {
      const { startTime } = action.payload;
      return { ...state, startTime };
    }

    case "SET_RECORDING_NOTIFICATION_STATUS": {
      const { recordingNotificationStatus } = action.payload;
      return { ...state, recordingNotificationStatus };
    }

    case "SET_LIVE_STREAMING_NOTIFICATION_STATUS": {
      const { liveStreamingNotificationStatus } = action.payload;
      return { ...state, liveStreamingNotificationStatus };
    }

    case "CLEAR_STATE":
      return initialState;

    case "IS_OFFICIAL_REPORT_OPEN_GLOBAL": {
      return { ...state, isOfficialReportOpenGlobal: action.payload };
    }
    default:
      return state;
  }
};

export default room;
